module.exports = __webpack_public_path__ + "static/media/tfh.78e7e9c5.png";